import React, { useEffect, useState } from 'react';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { OptionContainer, OptionFlag, OptionLabel } from './mixins';
import Countries from './countries';
import PhoneInputComponent from './PhoneInputComponent';
const MIN_PHONE_LENGTH = 7;
const MAX_LENGTH_NUMBER = 20;
const Option = ({ flag, dialCode }) => {
    return (React.createElement(OptionContainer, null,
        React.createElement(OptionFlag, { src: flag }),
        React.createElement(OptionLabel, null,
            "+",
            dialCode)));
};
const countriesCode = Countries.map((country) => ({
    value: country.dialCode,
    label: React.createElement(Option, { flag: country.flag, dialCode: country.dialCode }),
    code: country.code,
}));
const countriesReverseCode = countriesCode.reduce((accumulator, currentValue) => {
    accumulator[currentValue.value] = currentValue;
    return accumulator;
}, {});
const isValidFormat = (prefijo, numero) => {
    return isValidPhoneNumber(`${prefijo}${numero}`, countriesReverseCode[prefijo].code);
};
const validatePrefijoAndNumber = (prefijo, numero) => {
    return prefijo && numero ? numero.length < MIN_PHONE_LENGTH || !isValidFormat(prefijo, numero) : false;
};
const PhoneInput = ({ value, onChange, defaultPrefix, validateFormat = true, fieldOptions = {}, placeholder, rules, disabled, }) => {
    const { label, formatErrorText = 'Ingresa un teléfono válido.', maxHeight = '290px' } = fieldOptions;
    const [phone, setPhone] = useState(() => {
        var _a;
        return ({
            // eslint-disable-next-line prettier/prettier
            prefijo: (value === null || value === void 0 ? void 0 : value.prefijo) && countriesReverseCode[value.prefijo] ? value.prefijo : defaultPrefix,
            numero: (_a = value === null || value === void 0 ? void 0 : value.numero) !== null && _a !== void 0 ? _a : '',
        });
    });
    const [formatError, setFormatError] = useState(false);
    const errorMessageHandler = (prefijo, numero) => {
        if (validateFormat) {
            const isError = validatePrefijoAndNumber(prefijo, numero);
            setFormatError(isError);
        }
    };
    const changeInputHandler = (prefijo, numero) => {
        // Solo numeros
        if (numero && (!/^\d+$/.test(numero) || numero.length > MAX_LENGTH_NUMBER)) {
            return;
        }
        setPhone({
            prefijo,
            numero,
        });
        if (prefijo && numero) {
            onChange({
                prefijo,
                numero,
            }, validateFormat ? numero.length >= MIN_PHONE_LENGTH && isValidFormat(prefijo, numero) : true);
        }
        else {
            onChange(null, true);
        }
    };
    // Ejecutamos una validacion del telefono precargado
    useEffect(() => {
        errorMessageHandler(phone.prefijo, phone.numero);
        changeInputHandler(phone.prefijo, phone.numero);
    }, []);
    return (React.createElement(PhoneInputComponent, { countriesReverseCode: countriesReverseCode, phone: phone, countriesCode: countriesCode, formatError: formatError, errorMessageHandler: errorMessageHandler, changeInputHandler: changeInputHandler, label: label, rules: rules, maxHeight: maxHeight, placeholder: placeholder, setFormatError: setFormatError, formatErrorText: formatErrorText, disabled: disabled }));
};
export default PhoneInput;
